import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {SAMPLING_POINT_TYPES_QUERY_KEY} from '../../api/queries/getSamplingPointTypes'
import {getSamplingPointTypeOptions} from '../../helpers'
import {SamplingPointTypeOption} from '../../types'

import {useSettingsQuery} from '@settings/modules/common/providers'

export function useSamplingPointTypeOptionsQuery(): UseQueryResult<
  SamplingPointTypeOption[],
  unknown
> {
  const {t} = useTranslation()

  return useSettingsQuery(SAMPLING_POINT_TYPES_QUERY_KEY, [], {
    select: getSamplingPointTypeOptions,
    meta: {
      errorMessage: t('samplingPointsSettings.queries.fetchSamplingPointTypesError')
    }
  })
}
